import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-role-manager',
  templateUrl: './role-manager.component.html',
  styleUrls: ['./role-manager.component.css'],
})
export class RoleManagerComponent {
  roleManagerForm!: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  initForm() {
    this.roleManagerForm = this.formBuilder.group({
      roles: ['', Validators.required],
      securityPin: ['', Validators.required],
    });
  }
}
